import {
  Blade76,
  Blade89,
  Cell25,
  Cell45,
  Cell62,
  Chainless,
  Chainloop,
  ClearView,
  ControlBar,
  Corded,
  CordedLeft,
  Cordedloop,
  CordedRight,
  Cordless,
  CurtainCeilingMount,
  CurtainCentre,
  CurtainLeft,
  CurtainRight,
  DayNightBlindBottom,
  DayNightBlindTop,
  DoubleCell45,
  DoublePleat,
  DoubleTrack,
  HoneycombLightGuardsFalse,
  HoneycombLightGuardsTrue,
  InsideWindow,
  LeftChainPosition,
  MaterialBlockOut,
  MaterialLightFiltering,
  MaterialSheer,
  Motorised,
  NoTrack,
  OutsideWindow,
  PlasticChainType,
  RightChainPosition,
  RollerBackRoll,
  RollerFrontRoll,
  RollerLeftChainPosition,
  RollerLightGuardsFalse,
  RollerLightGuardsTrue,
  RollerRightChainPosition,
  RomanInsideWindow,
  RomanOutsideWindow,
  ShutterCenterFold,
  ShutterCenterOpening,
  ShutterCenterOpeningPostCenterOpening,
  ShutterCenterOpeningPostCenterOpeningPostCenterOpening,
  ShutterCenterOpeningPostCenterOpeningPostRight,
  ShutterCenterOpeningPostLeftOpeningPlusRightFold,
  ShutterCenterOpeningPostRight,
  ShutterCombinationFrame,
  ShutterDecorativeFrame,
  ShutterFaceFit,
  ShutterFaceFrame,
  ShutterLeftFold,
  ShutterLeftFoldPostRight,
  ShutterLeftFoldRight,
  ShutterLeftFoldRightPostCenterOpening,
  ShutterLeftFoldRightPostLeftFoldRight,
  ShutterLeftFoldRightPostLeftRightFold,
  ShutterLeftOpening,
  ShutterLeftOpeningPostCenterOpeningPostCenterOpening,
  ShutterLeftOpeningPostCenterOpeningPostRight,
  ShutterLeftPostCenterOpening,
  ShutterLeftPostLeftFoldRightFoldPostRight,
  ShutterLeftPostRightFold,
  ShutterLeftRightFoldPostLeftRightFold,
  ShutterRevealFit,
  ShutterRevealFrame,
  ShutterRightFold,
  ShutterRightFoldLeft,
  ShutterRightOpening,
  SinglePleatType,
  SingleTrack,
  Slat25mm,
  Slat50mm,
  Slat63mm,
  Smartglide,
  StainlessSteelChainType,
  VenetianCord,
  VenetianCordedLeft,
  VenetianCordedRight,
  VenetianFaceFit,
  VenetianRevealFit,
  VenetianTiltLeft,
  VenetianTiltRight,
  VenetianValanceFalse,
  VenetianValanceTrue,
  VenetianWand,
  WaveFold,
} from '../components/Icon';
// import {
//   PleatType,
//   VenetianValance,
// } from '../components/ProductBuilder/Section';
// import { RollerBlindFrontRoll } from '../components/ProductBuilder/Section/SectionImage/Roller/RollerBlind';
import { ProductBuilderMachineState } from '../types';

export type StateConfigType = {
  [key in ProductBuilderMachineState]?: {
    [key: string]: {
      icon?: Function;
      description?: string;
    };
  };
};

export type AllStateConfigType = {
  [key: string]: StateConfigType;
};

export const allowedBaseProductTypes = [
  'Honeycomb',
  'Honeycomb Vertical',
  'Roller Blind',
  'Roman Blinds',
  'Shutter',
  'Venetian',
  'Curtain',
];

export const honeycombStateConfig: StateConfigType = {
  materialType: {
    Sheer: {
      icon: MaterialSheer,
      description: 'Add a touch of luxury, great for layering',
    },
    'Light Filter': {
      icon: MaterialLightFiltering,
      description: 'Great for lounge rooms and kitchens',
    },
    Blockout: {
      icon: MaterialBlockOut,
      description: 'Great for bedrooms and media rooms',
    },
  },
  cellDesign: {
    'Single Cell 25mm': {
      icon: Cell25,
      description: 'Low profile for small reveals',
    },
    'Single Cell 45mm': {
      icon: Cell45,
      description: 'Larger pleats for a softer look',
    },
    'Double Cell 45mm': {
      icon: DoubleCell45,
      description: 'Increased insulation and sound reduction',
    },
    'Single Cell 62mm': {
      icon: Cell62,
      description: 'Larger pleats for a softer look',
    },
  },
  driveControl: {
    Cordless: {
      icon: Cordless,
      description: 'Simple, child safe, clean look',
    },
    Corded: {
      icon: Corded,
      description: 'Allrounder, suitable for most applications',
    },
    Cordloop: {
      icon: Cordedloop,
      description: 'Robust system for large windows',
    },
    Motorised: {
      icon: Motorised,
      description: 'Effortlessly control your blinds',
    },
  },
  fitting: {
    'Reveal Fit': {
      icon: InsideWindow,
      description:
        'Mounted inside within the window frame. We take deductions, please provide your exact measurements of your reveal with no deductions.',
    },
    'Face Fit': {
      icon: OutsideWindow,
      description:
        'Mounted to the architrave or wall surrounding the window. Please provide the exact measurements you would like your product made.',
    },
  },
  liftPosition: {
    Left: {
      icon: CordedLeft,
      description: 'Cord to lift blind on the left of the blind',
    },
    Right: {
      icon: CordedRight,
      description: 'Cord to lift blind on the right of the blind',
    },
  },
  lightGuards: {
    Yes: {
      icon: HoneycombLightGuardsTrue,
      description: 'Improved Blockout, great for bedrooms',
    },
    No: {
      icon: HoneycombLightGuardsFalse,
      description: 'Still a very good blockout!',
    },
  },
  dayFabricPosition: {
    Top: {
      icon: DayNightBlindTop,
      description: 'Privacy and natural light, great for bedrooms',
    },
    Bottom: {
      icon: DayNightBlindBottom,
      description: 'Lightcontrol for harsh midday sun',
    },
    Left: {},
    Right: {},
  },
  stackSide: {
    Left: {
      description: 'Perfect for left stacking doors',
    },
    Right: {
      description: 'Perfect for right stacking doors',
    },
    'Center Opening': {
      description: 'Perfect for centre opening doors',
    },
  },
};

export const honeycombVerticalStateConfig: StateConfigType = {
  materialType: {
    Sheer: {
      icon: MaterialSheer,
      description: 'Add a touch of luxury, great for layering',
    },
    'Light Filter': {
      icon: MaterialLightFiltering,
      description: 'Great for lounge rooms and kitchens',
    },
    Blockout: {
      icon: MaterialBlockOut,
      description: 'Great for bedrooms and media rooms',
    },
  },
  cellDesign: {
    'Single Cell 25mm': {
      icon: Cell25,
      description: 'Low profile for small reveals',
    },
    'Single Cell 45mm': {
      icon: Cell45,
      description: 'Larger pleats for a softer look',
    },
    'Double Cell 45mm': {
      icon: DoubleCell45,
      description: 'Increased insulation and sound reduction',
    },
    'Single Cell 62mm': {
      icon: Cell62,
      description: 'Larger pleats for a softer look',
    },
  },
  fitting: {
    'Reveal Fit': {
      icon: InsideWindow,
      description:
        'Mounted inside within the window frame. We take deductions, please provide your exact measurements of your reveal with no deductions.',
    },
    'Face Fit': {
      icon: OutsideWindow,
      description:
        'Mounted to the architrave or wall surrounding the window. Please provide the exact measurements you would like your product made.',
    },
  },
  liftPosition: {
    Left: {
      icon: CordedLeft,
      description: 'Cord to lift blind on the left of the blind',
    },
    Right: {
      icon: CordedRight,
      description: 'Cord to lift blind on the right of the blind',
    },
  },
  lightGuards: {
    Yes: {
      icon: HoneycombLightGuardsTrue,
      description: 'Improved Blockout, great for bedrooms',
    },
    No: {
      icon: HoneycombLightGuardsFalse,
      description: 'Still a very good blockout!',
    },
  },
  dayFabricPosition: {
    Top: {
      icon: HoneycombLightGuardsTrue,
      description: 'Privacy and natural light, great for bedrooms',
    },
    Bottom: {
      icon: HoneycombLightGuardsFalse,
      description: 'Lightcontrol for harsh midday sun',
    },
    Left: {},
    Right: {},
  },
  stackSide: {
    Left: {
      description: 'Perfect for left stacking doors',
    },
    Right: {
      description: 'Perfect for right stacking doors',
    },
    'Center Opening': {
      description: 'Perfect for centre opening doors',
    },
  },
};

export const rollerBlindStateConfig: StateConfigType = {
  materialType: {
    Sunscreen: {
      icon: MaterialSheer,
      description: 'Natural light control, great for living rooms',
    },
    'Light Filter': {
      icon: MaterialLightFiltering,
      description: 'Privacy and soft light for your home',
    },
    Blockout: {
      icon: MaterialBlockOut,
      description: 'Great for bedrooms and media rooms',
    },
  },
  materialTypeDay: {
    Sunscreen: {
      icon: MaterialSheer,
      description: 'Natural light control, great for living rooms',
    },
    'Light Filter': {
      icon: MaterialLightFiltering,
      description: 'Privacy and soft light for your home',
    },
    Blockout: {
      icon: MaterialBlockOut,
      description: 'Great for bedrooms and media rooms',
    },
  },
  materialTypeNight: {
    Sunscreen: {
      icon: MaterialSheer,
      description: 'Natural light control, great for living rooms',
    },
    'Light Filter': {
      icon: MaterialLightFiltering,
      description: 'Privacy and soft light for your home',
    },
    Blockout: {
      icon: MaterialBlockOut,
      description: 'Great for bedrooms and media rooms',
    },
  },
  dayFabricPosition: {
    Top: {
      icon: DayNightBlindTop,
      description:
        'Day fabric on top and rolls off the front\nNight fabric closest to window for better night privacy\nSome light leakage at top.',
    },
    Bottom: {
      icon: DayNightBlindBottom,
      description:
        'Day fabric at bottom and rolls off the back\nNight fabric rolls off the front\nReduced light leakage at top.',
    },
    Left: {},
    Right: {},
  },
  driveControl: {
    Chain: {
      icon: Chainloop,
      description: 'Chain drive operation',
    },
    Chainless: {
      icon: Chainless,
      description: 'Minimal design with smooth operation',
    },
    Smartglide: {
      icon: Smartglide,
      description: 'Minimal design with smooth operation',
    },
  },
  fitting: {
    'Reveal Fit': {
      icon: InsideWindow,
      description:
        'Mounted inside within the window frame. We take deductions, please provide your exact measurements of your reveal with no deductions.',
    },
    'Face Fit': {
      icon: OutsideWindow,
      description:
        'Mounted to the architrave or wall surrounding the window. Please provide the exact measurements you would like your product made.',
    },
  },
  lightGuards: {
    Yes: {
      icon: RollerLightGuardsTrue,
      description: 'Improved Blockout, great for bedrooms',
    },
    No: {
      icon: RollerLightGuardsFalse,
      description: '',
    },
  },
  rollDirection: {
    'Front Roll': {
      icon: RollerFrontRoll,
      description: 'Perfect for reveal fit blinds for a neat look',
    },
    'Back Roll': {
      icon: RollerBackRoll,
      description: 'Great for face fit blinds, improved privacy',
    },
  },
  chainPosition: {
    Left: {
      icon: RollerLeftChainPosition,
      description: '',
    },
    Right: {
      icon: RollerRightChainPosition,
      description: '',
    },
  },
  chainType: {
    Plastic: {
      icon: PlasticChainType,
      description: 'Standard Chain',
    },
    'Stainless Steel': {
      icon: StainlessSteelChainType,
      description: 'Premium Chain',
    },
  },
};

export const shutterStateConfig: StateConfigType = {
  fitting: {
    'Reveal Fit': {
      icon: ShutterRevealFit,
      description:
        'Mounted inside within the window frame. We take deductions, please provide your exact measurements of your reveal with no deductions.',
    },
    'Face Fit': {
      icon: ShutterFaceFit,
      description:
        'Mounted to the architrave or wall surrounding the window. Please provide the exact measurements you would like your product made.',
    },
  },
  frameStyle: {
    'Reveal Fit': {
      icon: ShutterRevealFrame,
      description: 'Simple shutter finish within the window',
    },
    'Combination Frame': {
      icon: ShutterCombinationFrame,
      description: 'Perfect for wonky windows hiding imperfections',
    },
    'Decorative Face Fit Frame': {
      icon: ShutterDecorativeFrame,
      description: 'A chic decorative frame to enchance windows',
    },
    'Face Fit Frame': {
      icon: ShutterFaceFrame,
      description: 'The perfect framed solution for face fit ',
    },
  },
  rollDirection: {
    'Front Roll': {
      description: 'Perfect for reveal fit blinds for a neat look',
    },
    'Back Roll': {
      description: 'Great for face fit blinds, improved privacy',
    },
  },
  bladeSize: {
    '76mm': {
      icon: Blade76,
      description: '',
    },
    '89mm': {
      icon: Blade89,
      description: '',
    },
  },
  operation: {
    'Clear View': {
      icon: ClearView,
      description: 'Blades are connect via a hidden bar',
    },
    'Control Bar': {
      icon: ControlBar,
      description: 'Tilt blades with a central bar',
    },
  },
  numberOfPanels: {
    '1 Panel': {
      icon: ShutterLeftOpening,
      description: '',
    },
    '2 Panels': {
      icon: ShutterCenterOpening,
      description: '',
    },
    '3 Panels': {
      icon: ShutterLeftPostRightFold,
      description: '',
    },
    '4 Panels': {
      icon: ShutterCenterFold,
      description: '',
    },
    '5 Panels': {
      icon: ShutterLeftOpeningPostCenterOpeningPostCenterOpening,
      description: '',
    },
    '6 Panels': {
      icon: ShutterCenterOpeningPostCenterOpeningPostCenterOpening,
      description: '',
    },
  },
  panelConfiguration: {
    'Left Opening': {
      icon: ShutterLeftOpening,
      description: '',
    },
    'Right Opening': {
      icon: ShutterRightOpening,
      description: '',
    },
    'Left Fold': {
      icon: ShutterLeftFold,
      description: '',
    },
    'Right Fold': {
      icon: ShutterRightFold,
      description: '',
    },
    'Center Opening': {
      icon: ShutterCenterOpening,
      description: '',
    },
    'Left Fold + Right': {
      icon: ShutterLeftFoldRight,
      description: '',
    },
    'Left + Right Fold': {
      icon: ShutterRightFoldLeft,
      description: '',
    },
    'Center Opening Fold': {
      icon: ShutterCenterFold,
      description: '',
    },
    'Left Fold, Post, Right': {
      icon: ShutterLeftFoldPostRight,
      description: '',
    },
    'Left, Post, Right Fold': {
      icon: ShutterLeftPostRightFold,
      description: '',
    },
    'Center Opening, Post, Right': {
      icon: ShutterCenterOpeningPostRight,
      description: '',
    },
    'Left, Post + Center Opening': {
      icon: ShutterLeftPostCenterOpening,
      description: '',
    },
    'Center Opening, Post, Center Opening': {
      icon: ShutterCenterOpeningPostCenterOpening,
      description: '',
    },
    'Left Opening, Post, Center Opening, Post, Right': {
      icon: ShutterLeftOpeningPostCenterOpeningPostRight,
      description: '',
    },
    'Left Fold + Right, Post, Center Opening': {
      icon: ShutterLeftFoldRightPostCenterOpening,
      description: '',
    },
    'Center Opening, Post, Left Opening + Right Fold': {
      icon: ShutterCenterOpeningPostLeftOpeningPlusRightFold,
      description: '',
    },
    'Center Opening, Post, Center Opening, Post, Right': {
      icon: ShutterCenterOpeningPostCenterOpeningPostRight,
      description: '',
    },
    'Left Opening, Post, Center Opening, Post, Center Opening': {
      icon: ShutterLeftOpeningPostCenterOpeningPostCenterOpening,
      description: '',
    },
    'Left Fold + Right, Post, Left Fold + Right': {
      icon: ShutterLeftFoldRightPostLeftFoldRight,
      description: '',
    },
    'Left Fold + Right, Post, Left + Right Fold': {
      icon: ShutterLeftFoldRightPostLeftRightFold,
      description: '',
    },
    'Left + Right Fold, Post, Left + Right Fold': {
      icon: ShutterLeftRightFoldPostLeftRightFold,
      description: '',
    },
    'Left, Post, Center Opening Fold, Post, Right': {
      icon: ShutterLeftPostLeftFoldRightFoldPostRight,
      description: '',
    },
    'Center Opening, Post, Center Opening, Post, Center Opening': {
      icon: ShutterCenterOpeningPostCenterOpeningPostCenterOpening,
      description: '',
    },
  },
};

export const curtainStateConfig: StateConfigType = {
  materialType: {
    Sheer: {
      icon: MaterialSheer,
      description: 'A luxurous addition to lift any living space',
    },
    Standard: {
      icon: MaterialBlockOut,
      description: 'Perfect for Bedrooms a lounge rooms',
    },
  },
  wand_colour: {
    Black: {
      icon: VenetianWand,
      description: 'Black wand for operating the blind',
    },
    White: {
      icon: VenetianWand,
      description: 'White wand for operating the blind',
    },
    No: {
      icon: NoTrack,
      description: 'No wand required',
    },
  },
  transparency: {
    Sheer: {
      icon: MaterialSheer,
      description:
        'See-through fabrics that gently diffused light, great for layering',
    },
    'In-between/Dim Out': {
      icon: MaterialLightFiltering,
      description:
        'Dims or softens light based on the fabric selection, ideal for living spaces',
    },
    'Semi-Transparent': {
      icon: MaterialLightFiltering,
      description:
        'Allows filtered light while maintaining privacy, ideal for living spaces',
    },
    'Semi-transparent': {
      icon: MaterialLightFiltering,
      description:
        'Allows filtered light while maintaining privacy, ideal for living spaces',
    },
    Blockout: {
      icon: MaterialBlockOut,
      description: 'Blocks out light, ideal for bedrooms and media rooms',
    },
  },
  pleatType: {
    'Single Pleat': {
      icon: SinglePleatType,
      description: 'Classic look with clean lines',
    },
    'Double Pleat': {
      icon: DoublePleat,
      description: 'Full bodied and versatile curtain style',
    },
    'Wave Pleat': {
      icon: WaveFold,
      description: 'Modern design that adds an elegant touch',
    },
  },
  configuration: {
    'Left Stack (1 Curtain)': {
      icon: CurtainLeft,
    },
    'Right Stack (1 Curtain)': {
      icon: CurtainRight,
    },
    'Centre Opening (2 Curtains)': {
      icon: CurtainCentre,
    },
  },
  fitting: {
    'Wall Mount': {
      icon: CurtainCentre,
      description: 'Track mounted oF the wall or architrave using L-brackets.',
    },
    'Ceiling Mount': {
      icon: CurtainCeilingMount,
      description:
        'Track mounted within the frame of the window/door or on the ceiling.',
    },
  },
  track: {
    'No Thanks': {
      icon: NoTrack,
      description: 'Mounting curtains into existing curtain tracks',
    },
    'Single Track': {
      icon: SingleTrack,
      description: 'Add a track to mount your curtain on',
    },
    'Double Track': {
      icon: DoubleTrack,
      description: 'Select if mounting two curtains in same window',
    },
  },
  lining: {
    Sheer: {
      icon: MaterialSheer,
      description: 'See-through fabrics that gently diffused light, great for layering',
    },
    'In-between/Dim Out': {
      icon: MaterialLightFiltering,
      description: 'Dims or softens light based on the fabric selection, ideal for living spaces',
    },
    Blockout: {
      icon: MaterialBlockOut,
      description: 'Blocks out light, ideal for bedrooms and media rooms',
    },
    Lined: {
      // icon: NoTrack,
      description: 'Provides complete blockout and extra insulation',
    },
    Unlined: {
      // icon: NoTrack,
      description: 'No lining behind curtain',
    },
    'Block-out': {
      // icon: NoTrack,
      description: 'Blocks all light for complete darkness and privacy',
    },
    'Semi-Transparent': {
      // icon: MaterialLightFiltering,
      description: 'Allows filtered light while maintaining privacy',
    },
    'Semi-transparent': {
      // icon: MaterialLightFiltering,
      description: 'Allows filtered light while maintaining privacy',
    },
  },
  pleatFinish: {
    Standard: {
      // icon: NoTrack,
      description: 'Provides complete blockout and extra insulation',
    },
    Royal: {
      // icon: NoTrack,
      description: 'Provides complete blockout and extra insulation',
    },
  },
  pullRod: {
    'No Thanks': {
      icon: NoTrack,
      description: 'Mounting curtains into existing curtain tracks',
    },
    '1x pull rod': {
      icon: SingleTrack,
      description: 'Add a track to mount your curtain on',
    },
    '2x pull rod': {
      icon: DoubleTrack,
      description: 'Select if mounting two curtains in same window',
    },
  },
};

export const romanStateConfig: StateConfigType = {
  lining: {
    'Light Filter': {
      icon: MaterialLightFiltering,
      description: 'Great for lounge rooms and kitchens',
    },
    Blockout: {
      icon: MaterialBlockOut,
      description: 'Great for bedrooms and media rooms',
    },
  },
  driveControl: {
    Chain: {
      icon: Chainloop,
      description: 'Simple and easy to use chain system',
    },
    Chainless: {
      icon: Chainless,
      description: 'Simple, child safe, clean look',
    },
  },
  fitting: {
    'Reveal Fit': {
      icon: RomanInsideWindow,
      description:
        'Mounted inside within the window frame. We take deductions, please provide your exact measurements of your reveal with no deductions.',
    },
    'Face Fit': {
      icon: RomanOutsideWindow,
      description:
        'Mounted to the architrave or wall surrounding the window. Please provide the exact measurements you would like your product made.',
    },
  },
  chainType: {
    Plastic: {
      icon: PlasticChainType,
      description: 'Standard Chain',
    },
    'Stainless Steel': {
      icon: StainlessSteelChainType,
      description: 'Premium Chain',
    },
  },
  chainPosition: {
    Left: {
      icon: LeftChainPosition,
      description: '',
    },
    Right: {
      icon: RightChainPosition,
      description: '',
    },
  },
};

export const venetianStateConfig: StateConfigType = {
  slatSize: {
    '25mm': {
      icon: Slat25mm,
      description: 'Modern slimline design',
    },
    '50mm': {
      icon: Slat50mm,
      description: 'Traditial Venetian look and functionality',
    },
    '63mm': {
      icon: Slat63mm,
      description: 'Generous shutter look at venetian cost',
    },
  },
  fitting: {
    'Reveal Fit': {
      icon: VenetianRevealFit,
      description:
        'Mounted inside within the window frame. We take deductions, please provide your exact measurements of your reveal with no deductions.',
    },
    'Face Fit': {
      icon: VenetianFaceFit,
      description:
        'Mounted to the architrave or wall surrounding the window. Please provide the exact measurements you would like your product made.',
    },
  },
  tiltControl: {
    Cord: {
      icon: VenetianCord,
      description: 'Traditional finish accross the blind',
    },
    Wand: {
      icon: VenetianWand,
      description: 'Improved tilt control and child safety',
    },
  },
  venetianValance: {
    Yes: {
      icon: VenetianValanceTrue,
      description: 'Traditional finish covering the headrail',
    },
    No: {
      icon: VenetianValanceFalse,
      description: 'Simple and modern, great for smaller reveals',
    },
  },
  liftPosition: {
    Left: {
      icon: VenetianCordedLeft,
      description: '',
    },
    Right: {
      icon: VenetianCordedRight,
      description: '',
    },
  },
  tiltPosition: {
    Left: {
      icon: VenetianTiltLeft,
      description: '',
    },
    Right: {
      icon: VenetianTiltRight,
      description: '',
    },
  },
  driveControl: {
    Cordless: {
      icon: Cordless,
      description: 'Simple, child safe, clean look',
    },
    Corded: {
      icon: Corded,
      description: 'Allrounder, suitable for most applications',
    },
  },
};

export const productStateConfig: AllStateConfigType = {
  Honeycomb: honeycombStateConfig,
  'Honeycomb Vertical': honeycombStateConfig,
  'Roller Blind': rollerBlindStateConfig,
  'Roman Blinds': romanStateConfig,
  Shutter: shutterStateConfig,
  Venetian: venetianStateConfig,
  Curtain: curtainStateConfig,
};
